import { createApp, h } from 'vue';
import { EventTypes } from './delivery-address-events';
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import CurrentDeliveryAddress from './components/current-delivery-address';
import i18n from './vue-deliveryaddress-i18n';

let vueShowDeliveryAddressApp = null;
PubSub.subscribe(EventTypes.SHOW_CURRENT_ADDRESS, (eventName, params) => {
    if (vueShowDeliveryAddressApp !== null)
        vueShowDeliveryAddressApp.unmount();

    vueShowDeliveryAddressApp = createApp({
        components: { 'current-delivery-address': CurrentDeliveryAddress },
        render: () => h(CurrentDeliveryAddress),
    });
    vueShowDeliveryAddressApp.use(i18n);
    vueShowDeliveryAddressApp.use(ToastPlugin, {
        duration: 5000,
        position: 'bottom-right'
    });
    vueShowDeliveryAddressApp.config.globalProperties.$currentDeliveryAddressDeleteActive = params.isDeleteActive;
    vueShowDeliveryAddressApp.config.globalProperties.$currentDeliveryAddressTargetSelector = params.targetSelector;
    vueShowDeliveryAddressApp.config.globalProperties.$currentDeliveryAddressIsPreview = params.isPreview;
    vueShowDeliveryAddressApp.config.globalProperties.$currentDeliveryAddressDeleteTargetSelector = params.deleteTargetSelector;
    vueShowDeliveryAddressApp.config.globalProperties.$currentDeliveryAddressIsReadOnly = params.isReadOnly;    
    vueShowDeliveryAddressApp.mount("#vue-app-plch");
});

PubSub.subscribe(EventTypes.UNMOUNT_DELIVERY_ADDRESS_APP, (eventName, params) => {
    if (vueShowDeliveryAddressApp === null)
        return;
    vueShowDeliveryAddressApp.unmount();
});